// extracted by mini-css-extract-plugin
export var cite = "bw_dW";
export var inlineSourceLink = "bw_dV";